/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Rule} from "../models/rule";
import {RulesService} from "../services/rules.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class RulesPagingResolver implements Resolve<PagedResults<Rule>> {

  constructor(
    private mRuleService: RulesService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<Rule>> {
    try {
      return await this.mRuleService.getAllRulesForPaging(0, PAGING_ITEMS_PER_PAGE, 'ASC', "");
    } catch (error) {
      console.error("Problem resolving Rules... Error: " + error, error);
    }
  }

}
